<template>
    <div v-if="!loader">
        <div class="row align-items-center justify-content-center mb-3">
            <div class="text-center middleBox">
                <h2 class="mb-3">{{$t('trade_cal_title')}}</h2>
                <p>{{$t('trade_cal_title_Txt')}}</p>
            </div>
        </div>
        <div class="whiteBG"> 
            <section class="blockElement doticonHover tp homeContact position-relative between-footer"> 
                <div class="row justify-content-center tabbable tabbingBlock">
                    <div class="col-12 col-md-3">
                        <ul class="nav nav-tabs mr-5 leftCustom-width in-trading">
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('zero')" :class="(showData == 'zero')?'active' : ''">{{$t('trade_cal_Commission')}}  <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('one')" :class="(showData == 'one')?'active' : ''">{{$t('OCtradelist_margin')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('two')" :class="(showData == 'two')?'active' : ''">{{$t('trade_cal_Multi_Target')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('three')" :class="(showData == 'three')?'active' : ''">{{$t('trade_cal_Pivot_Points')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('four')" :class="(showData == 'four')?'active' : ''">{{$t('trade_cal_Profit_Loss')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('six')" :class="(showData == 'six')?'active' : ''">{{$t('trade_cal_Fibonacci')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('seven')" :class="(showData == 'seven')?'active' : ''">{{$t('trade_cal_Pip_Value')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('eight')" :class="(showData == 'eight')?'active' : ''">{{$t('trade_cal_Swap')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('nine')" :class="(showData == 'nine')?'active' : ''">{{$t('trade_cal_Position_Size')}} <feather type="chevron-right"></feather></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#" v-on:click.prevent="tabFunc('eleven')" :class="(showData == 'eleven')?'active' : ''">{{$t('trade_cal_Currency_Convertor')}} <feather type="chevron-right"></feather></a>
                            </li>
                        </ul>
 
                    </div>
                    <div class="col-12 col-md-9">
                        <div class="tab-content rightCustom-width">
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('zero')" :class="(showData == 'zero')?'active' : ''">Commission </a> -->
                            <div class="tab-pane active" v-if="showData == 'zero'">
                                <commission></commission>
                            </div>
							
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('one')" :class="(showData == 'one')?'active' : ''">Margin</a> -->
                            <div class="tab-pane active" v-if="showData == 'one'">
                                <margin></margin>
                            </div>
							
							<!-- <a class="nav-link" href="#"  v-on:click.prevent = "tabFunc('two')" :class="(showData == 'two')?'active' : ''">Multi-Target</a> -->
                            <div class="tab-pane active" v-if="showData == 'two'">
                                <multi-target></multi-target>
                            </div>
							
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('three')" :class="(showData == 'three')?'active' : ''">Pivot Points</a> -->
                            <div class="tab-pane active" v-if="showData == 'three'">
                                <pivot-points></pivot-points>
                            </div>
							
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('four')" :class="(showData == 'four')?'active' : ''">Profit & Loss</a> -->
                            <div class="tab-pane active" v-if="showData == 'four'">
                                <profit-loss></profit-loss>
                            </div>
							
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('six')" :class="(showData == 'six')?'active' : ''">Fibonacci</a> -->
                            <div class="tab-pane active" v-if="showData == 'six'">
                                <fibonacci></fibonacci>
                            </div>
							
							<!-- <a class="nav-link" href="#"  v-on:click.prevent = "tabFunc('seven')" :class="(showData == 'seven')?'active' : ''">Pip Value</a> -->
                            <div class="tab-pane active" v-if="showData == 'seven'">
                                <pip-value></pip-value>
                            </div>
							
							<!-- <a class="nav-link" href="#"  v-on:click.prevent = "tabFunc('eight')" :class="(showData == 'eight')?'active' : ''">Pip Value</a> -->
                            <div class="tab-pane active" v-if="showData == 'eight'">
                                <swap></swap>
                            </div>
							
							<!-- <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('nine')" :class="(showData == 'nine')?'active' : ''">Position Size</a> -->
                            <div class="tab-pane active" v-if="showData == 'nine'">
                                <position-size></position-size>
                            </div>
							
							<!-- <a class="nav-link" href="#"  v-on:click.prevent = "tabFunc('eleven')" :class="(showData == 'eleven')?'active' : ''">Currency Convertor</a> -->
                            <div class="tab-pane active" v-if="showData == 'eleven'">
                                <currency-convertor></currency-convertor>
                            </div>
                        </div>
                    </div>
                </div> 
            </section>
        </div>
    </div>
</template>
<script>
    import left_menu from '../../shared/calculators/leftmenu'
    import commission from '../../shared/calculators/commission'
    import margin from '../../shared/calculators/margin'
    import multi_target from '../../shared/calculators/multi_target'
    import profit_loss from '../../shared/calculators/profit_Loss'
    import pivot_points from '../../shared/calculators/pivot_points'
    import risk_rewards from '../../shared/calculators/risk_rewards'
    import fibonacci from '../../shared/calculators/fibonacci'
    import pip_value from '../../shared/calculators/pip_value'
    import swap from '../../shared/calculators/swap'
    import position_size from '../../shared/calculators/position_size'
    import risk_percentage from '../../shared/calculators/risk_percentage'
    import currency_convertor from '../../shared/calculators/currency_convertor'
    // import { ConstCache } from '@/plugins/vue-provider-cache/const.mod'
    import * as types from '@/types'
    import { fxViewMixins } from '@/plugins/fxView' 

    export default {
        name: 'trading-calculators',
        mixins: [fxViewMixins],
        data() {
            return {
				showData : 'zero',
                isinsListData:{},
                loader:true
            }
        },
        watch:{
			fetchedIsins(newVal, oldVal) {
				if(newVal){
                    this.loader= false
					this.isinsListData = Object.keys(newVal);
					this.currencyListSubscribe() 
				}else{
					return;
				}
			},
		},
        components:{
            leftMenu: left_menu,
            commission: commission,
            margin: margin,
            multiTarget: multi_target,
            profitLoss: profit_loss,
            pivotPoints: pivot_points,
            riskRewards: risk_rewards,
            fibonacci: fibonacci,
            pipValue: pip_value,
            swap: swap,
            positionSize: position_size,
            riskPercentage: risk_percentage,
            currencyConvertor: currency_convertor
        },
        computed: {
			fetchedIsins(){
				return this.$store.getters['/GET_ISINS_LIST'];
			}
		},
		methods:{
            currencyListSubscribe(){
				let list = this.isinsListData;
				this.$websocket.sendWatchlist(list);
			},
            getAllIsins(){
                this._runGetIsinsList()
            },
			tabFunc(getData){
				this.showData = getData
			}
		},
        created(){
            this.getAllIsins()
            this.fetchedIsins
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/tools/pages/trading_calculators.vue